import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // NOTE: 業務系システムで更新削除等の処理が種々の処理に関わっているため、
      //       基本方針としてキャッシュしない方が安全に運用できるので、グローバル設定は0にする
      //       個別にキャッシュを有効にしたい場合は各fetch処理側でstaleTimeを設定する。
      staleTime: 0,
    },
  },
});
